import gcinstant from '@play-co/gcinstant';
import { AssetGroup } from '@play-co/timestep-core';
import { ImageView, View } from '@play-co/timestep-core/ui';
import PopupBasicLazy from 'src/game/components/popups/PopupBasicLazy';
import i18n from 'src/lib/i18n/i18n';
import sounds from 'src/lib/sounds';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import { Feature } from 'src/replicant/analytics';
import { getDynamicTestBucket } from 'src/replicant/getters/ab';
import ab from 'src/replicant/ruleset/ab';
import { assertNever } from 'src/replicant/utils';
import StateObserver from 'src/StateObserver';
import uiConfig from 'src/lib/ui/config';
import bitmapFonts from 'src/lib/bitmapFonts';
import {
  trackNativeDialogButton,
  trackNativeDialogView,
} from 'src/lib/analytics/events';
import { getNativeStoreLink } from '../native.util';

/**
 * Improved version of PopupInstallAppAndroid and PopupInstallAppIos
 * TEST_APP_INSTALL_NUDGE_POPUP_VARIANT
 */
export default class PopupInstallNativeApp extends PopupBasicLazy {
  public constructor(opts: { superview: View; close: () => void }) {
    super({
      ...opts,
      width: 720,
      height: 1184,
      skipMessage: true,
      skipTitle: true,
      tracking: {
        feature: Feature.NATIVE._,
        $subFeature:
          gcinstant.osType === 'IOS'
            ? Feature.NATIVE.POPUP_INSTALL_IOS
            : gcinstant.osType === 'ANDROID'
            ? Feature.NATIVE.POPUP_INSTALL_ANDROID
            : Feature.NATIVE.POPUP_INSTALL_UNKNOWN,
      },
    });

    this.box.removeFromSuperview();
    this.box = this.createBackgroundImage(this.root);

    this.box.addSubview(this.buttonClose);
    this.buttonClose.onClick = async () => {
      sounds.sfx.play('cancel');
      return opts.close();
    };
    this.buttonClose.updateOpts({
      width: 80,
      height: 80,
      x: 613,
      y: 63,
    });

    this.createOKButton(this.box);
  }

  /**
   * Lazy load group
   */
  protected getAssetsGroup(): AssetGroup {
    return new AssetGroup(['']); //[this.getPopupBackground().image]);
  }

  /**
   * Create main background view of popup
   */
  private createBackgroundImage(superview: View) {
    return new ImageView({
      superview,
      // ...this.getPopupBackground(),
      infinite: true,
      canHandleEvents: false,
      x: superview.style.width * 0.5,
      y: superview.style.height * 0.5,
      centerOnOrigin: true,
      centerAnchor: true,
    });
  }

  /**
   * Create OK button
   */
  private createOKButton(superview: View) {
    return new ButtonScaleViewWithText({
      superview,
      ...uiConfig.buttons.secondary,
      fontSize: 48,
      font: bitmapFonts('Body'),
      width: 228,
      height: 82,
      x: (superview.style.width - 228) * 0.5,
      y: 1013,
      labelOffsetX: -6,
      labelOffsetY: -2,
      localeText: () => i18n('basic.ok'),
      onClick: async () => {
        this.openStore();
        return this.opts.close();
      },
      tracking: {
        feature: Feature.NATIVE._,
        $subFeature:
          gcinstant.osType === 'IOS'
            ? Feature.NATIVE.DOWNLOAD_IOS
            : gcinstant.osType === 'ANDROID'
            ? Feature.NATIVE.DOWNLOAD_ANDROID
            : Feature.NATIVE.DOWNLOAD_UNKNOWN,
      },
    });
  }

  /**
   * On dialog open
   */
  init(opts: {}) {
    super.init({});
    trackNativeDialogView(this.getPlatformForAnalytics());
  }

  /**
   * Open native app store
   */
  private openStore() {
    sounds.sfx.play('ok');
    trackNativeDialogButton(this.getPlatformForAnalytics());
    window.open(getNativeStoreLink());
  }

  /**
   * Analytics helper
   */
  private getPlatformForAnalytics(): 'ios' | 'android' | 'unknown' {
    return gcinstant.osType === 'IOS'
      ? 'ios'
      : gcinstant.osType === 'ANDROID'
      ? 'android'
      : 'unknown';
  }

  /**
   * Get popup background
   */
  private getPopupBackground() {
    const { user } = StateObserver.getState();
    const locale = StateObserver.getLocale();
    const test = 'control';
    const assets = `${test}_${locale}` as const;

    /*
    switch (assets) {
      case 'reward_en':
        return {
          image: 'assets/native/install_nudges/reward_en.png',
          width: 720,
          height: 1180,
        };
      case 'reward_ja':
        return {
          image: 'assets/native/install_nudges/reward_ja.png',
          width: 720,
          height: 1184,
        };
      case 'exclusive_character_en':
        return {
          image: 'assets/native/install_nudges/exclusive_character_en.png',
          width: 720,
          height: 1180,
        };
      case 'exclusive_character_ja':
        return {
          image: 'assets/native/install_nudges/exclusive_character_ja.png',
          width: 720,
          height: 1184,
        };
      case 'control_en':
      case 'control_ja':
        throw new Error('Control bucket not supported');
      default:
        assertNever(assets);
    }
    */
  }
}
